import { useState } from "react";
import { Service, LaptopCare, Laptop } from "../../../assets/Home";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchCounts } from "../../../redux/actions/countActions";
import { toast } from "react-toastify";
const images = [
  {
    src: Service,
    title: "Repair Services",
    path:"/service",
  },
  {
    src: LaptopCare,
    title: "Laptop Accessories",
    path:"/productpage",
  },
  {
    src: Laptop,
    title: "Latest Laptops",
    path:"/productpage",
  },
];

export default function SectionOne() {
  const [selected, setSelected] = useState(0);
  const navigate=useNavigate();
  const dispatch = useDispatch();
  const storedUser = localStorage.getItem("customeruser");
  const { counts, error } = useSelector(state => state.countState);

  useEffect(() => {
    dispatch(fetchCounts());
  }, [dispatch]);

  useEffect(() => {
  const interval = setInterval(() => {
    setSelected(prev => (prev + 1) % images.length);
  }, 3000);

  return () => clearInterval(interval);
  }, []);

  const handleBookService = () => {
      if (storedUser) {
        navigate("/bookservice");
      } else {
        toast.warning("Please login to continue");
        setTimeout(() => navigate("/login"), 1000);
        return;
      }
  };

  const handleBookProduct = () => {
      if (storedUser) {
        navigate("/productpage");
      } else {
        toast.warning("Please login to continue");
        setTimeout(() => navigate("/login"), 1000);
        return;
      }
  };

  if (error) return <p className="text-red-500">{error}</p>;
  
  return (
    <section className="bg-zinc-700 text-white px-6 py-8 lg:min-h-screen">
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex flex-col lg:gap-6 w-full md:w-2/5">
          <h1 className="text-2xl md:text-3xl xl:text-4xl font-semibold leading-snug  max-w-sm">
            Elevate Your <span className="text-red-700">Tech</span> Experience
          </h1>
          <p className="text-gray-300 mt-4 mb-6 max-w-sm">
            Get the best devices, essential accessories, and professional repairs under one roof.
          </p>
          <div className="flex gap-4 text-xs md:text-sm xl:text-base">
            <button className="bg-white text-red-700 px-6 py-2 rounded-lg font-medium hover:bg-gray-50 hover:scale-105"
            onClick={handleBookService}>
              Book Service
            </button>
            <button className="border border-white text-white px-6 py-2 rounded-lg flex items-center gap-1 hover:bg-white hover:text-black hover:scale-105"
            onClick={handleBookProduct}>
              Shop now
            </button>
          </div>
          <div className="flex gap-8 mt-5 lg:mt-10 flex-wrap text-white">
        <div>
          <h2 className="text-xl md:text-2xl xl:text-3xl font-bold">{counts.totalProducts}+</h2>
          <p className="text-sm md:text-base xl:text-lg">products</p>
        </div>
        <div>
          <h2 className="text-xl md:text-2xl xl:text-3xl font-bold">{counts.totalCategories}+</h2>
          <p className="text-sm md:text-base xl:text-lg">categories</p>
        </div>
        <div>
          <h2 className="text-xl md:text-2xl xl:text-3xl font-bold">{counts.totalCustomers}+</h2>
          <p className="text-sm md:text-base xl:text-lg">happy clients</p>
        </div>
      </div>
        </div>

        <div className="flex flex-row justify-center gap-4 w-full h-full md:w-3/5">
          {images.map((img, index) => (
            <div
              key={index}
              onClick={() => setSelected(index)}
              className={`relative rounded-lg cursor-pointer overflow-hidden transition-all duration-300 ${
                selected === index ? "w-full" : "w-[48%]"
              }`}
            >
              <img
                src={img.src}
                alt={img.title}
                className="rounded-lg w-full h-48 md:h-96 lg:h-[500px] object-cover"
              />
             
             {selected === index && (
              <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 hover:opacity-100 flex flex-col md:flex-row justify-end md:justify-between items-center md:items-end transition-all duration-300 pb-3 md:px-1 xl:px-5">
                <h3 className="text-sm xl:text-lg font-bold text-center">{img.title}</h3>
                <button className="text-xs xl:text-sm" 
                onClick={()=>navigate(img.path)}>View More</button>
              </div>
             )}
            </div>
            
          ))}
        </div>
      </div>

     
      
    </section>
  );
}
